import HTTP from '../../Infra/Http'

export const getAllPlants = async () => {
  return await HTTP.Get('/api/plants/');
};

export const getPlantById = async (id) => {
  return await HTTP.Get(`/api/plants/item/${id}`);
};

export const getActivePlantGroups = async () => {
  return await HTTP.Get('/api/plants/group/active/list');
};

export const getPlantsByGroup = async (groupId) => {
  return await HTTP.Get(`/api/plants/group/${groupId}/plants`);
};

export const searchPlants = async (query) => {
  return await HTTP.Get(`/api/plants/search?q=${query}`);
};

export const getActivePlantDetails = async (id) => {
  return await HTTP.Get(`/api/plants/details/${id}`);
};